const PAYMENT_CATEGORIES = {
    PAYMENT: 'payment',
    BULK_PAYMENT: 'payment-approve-all',
    CROSSBORDER_PAYMENT: 'cross-border-payment',
    DOWNPAYMENT: 'downpayment',
    EFAKTURA: 'efaktura',
    BATCH_EFAKTURA: 'batch-efaktura',
};

const AVATALEGIRO_CATEGORIES = {
    CREATE_AVTALEGIRO: 'create-avtalegiro',
    UPDATE_AVTALEGIRO: 'update-avtalegiro',
    DELETE_AVTALEGIRO: 'delete-avtalgiro',
};

const ANALYTICS_CATEGORIES = {
    ...PAYMENT_CATEGORIES,
    ...AVATALEGIRO_CATEGORIES,
    SHARE_EFAKTURA: 'share-eFaktura',
    TRANSFER: 'transfer',
    UPDATE_PAYMENT_LIMITS: 'update-payment-limits',
    UPDATE_RECEIVER: 'update-receiver',
    UPDATE_PAYMENT_ITEM: 'update-payment-item',
    CLOSE_ACCOUNT: 'close-account',
    UPDATE_CONTACT_INFO: 'update-contact-info',
};

export default ANALYTICS_CATEGORIES;
